<script>
    import { user } from "../../stores";

    import { DirectUserRoles } from "../../Utils/utilEnums.svelte";

    import AdminDashboard from "./pages/AdminDashboard.svelte";
    import ManagerDashboard from "./pages/ManagerDashboard.svelte";
    import DoctorDashboard from "./pages/DoctorDashboard.svelte";
    import DefaultDashboard from "./pages/DefaultDashboard.svelte";

    $: isUserAdmin = $user.role === DirectUserRoles.Admin;

    $: isUserManager = $user.role === DirectUserRoles.Manager;

    $: isUserSupport = $user.role == DirectUserRoles.Support;

    $: isUserDoctor = $user.role === DirectUserRoles.Doctor;
</script>

<div class="flex flex-col h-full">
    {#if isUserAdmin}
        <AdminDashboard />
    {:else if isUserManager}
        <ManagerDashboard />
    {:else if isUserDoctor}
        <DoctorDashboard />
    {:else}
        <DefaultDashboard />
    {/if}
</div>
